import { TabNavigationModel } from "@shared/components/tab-navigation/tab-navigation.model";

export const routesConfiguracionClientes: TabNavigationModel[] = [
    {
        url: '../categorias',
        title: 'Categorías'
    },
    {
        url: '../campos-informacion',
        title: 'Campos de información'
    },
]

export const routesConfiguracionClientesTitle = "Configuración de clientes"